// ─── GRASSROOTING TEAM DATA ──────────────────────────────────────────────────
// ONE example listing shown as a demo — real listings will be added by managers
// To add a team, copy the example below and update the details

export const teams = [
  {
    id: 1,
    club: "Riverside Rangers Youth FC",
    league: "Example Youth League",
    division: "Division 1",
    day: "Saturday",
    ageGroup: "U10",
    region: "Hampshire",
    town: "Winchester",
    level: "Developing",
    levelDesc: "A friendly, welcoming U10 side playing Saturday mornings. We focus on player development and having fun. Players of all abilities are welcome to come for a trial — just get in touch with the manager below.",
    positions: ["Goalkeeper", "Striker", "Midfielder"],
    contact: "manager@riversiderangers.com",
    phone: "07700 900000",
    posted: "Today",
    badge: "🟢",
    colour: "#10b981",
    isExample: true,
  },
];

export const AGE_GROUPS = ["All","U7","U8","U9","U10","U11","U12","U13","U14","U15","U16"];
export const DAYS       = ["All","Saturday","Sunday"];
export const DIVISIONS  = ["All","Premier Division","Division 1","Division 2","Division 3"];
export const LEVELS     = ["All","Beginners Welcome","Developing","Competitive","Elite"];
export const LEAGUES    = ["All"];

export const LEVEL_COLOURS = {
  "Beginners Welcome": { bg:"#d1fae5", text:"#065f46", dot:"#10b981" },
  "Developing":        { bg:"#dbeafe", text:"#1e40af", dot:"#3b82f6" },
  "Competitive":       { bg:"#fef3c7", text:"#92400e", dot:"#f59e0b" },
  "Elite":             { bg:"#fee2e2", text:"#991b1b", dot:"#ef4444" },
};

export const ads = [
  { brand:"ProDirect Soccer", tagline:"Kit your team out this season — grassroots discounts available", cta:"Shop Now",    accent:"#f59e0b", bg:"#1c1c2e" },
  { brand:"Forza Goals",      tagline:"Training goals & equipment for grassroots clubs from £29",      cta:"View Range",  accent:"#10b981", bg:"#0f1f1a" },
  { brand:"Samba Sports",     tagline:"Bespoke kit printing from £8/shirt",                            cta:"Get a Quote", accent:"#e11d48", bg:"#1f0a10" },
];
